import type {Identity} from '../utils';
import {identityPrimary, identitySecondary, initialsFrom} from '../utils';
import {CopyCode} from './CopyCode';

/**
 * Une seule identité par compte : nom ou e-mail en principal, UID mono secondaire et copiable.
 * L'avatar tire ses initiales du nom ou de l'e-mail, jamais de l'UID.
 */
/** `copy={false}` dans une ligne de liste : un bouton ne peut pas contenir un autre bouton. */
export function IdentityCell({identity, big = false, showUid = true, pending = false, copy = true}: {identity: Identity; big?: boolean; showUid?: boolean; pending?: boolean; copy?: boolean}) {
  const primary = identityPrimary(identity);
  const secondary = identitySecondary(identity);
  return <div className={big ? 'ident big' : 'ident'}>
    <span className="avatar">{initialsFrom(identity.displayName, identity.email)}</span>
    <div className="ident-text">
      {primary ? <strong>{primary}</strong> : <strong className="unknown">{pending ? 'Identité…' : 'Identité non résolue'}</strong>}
      {secondary && <span className="sub">{secondary}</span>}
      {showUid && <span className="uid"><code>{identity.uid}</code>{copy && <CopyCode value={identity.uid} label="l’UID" />}</span>}
    </div>
  </div>;
}
